var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25.365507mm",
    height: "21.061619mm",
    viewBox: "0 0 25.365507 21.061619",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-263.70189,-203.48061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(1.6975572,0,0,1.6975572,-212.69053,-156.22253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "UI_Circle_reddish-7",
    d: "m 283.8002,213.26488 -3.05621,2.78488 -0.1099,4.09981 1.54283,3.24688 3.92252,0.90513 3.81614,-1.69912 2.03676,-3.81509 -1.67161,-4.66905 -4.51152,-0.82804 z",
    fill: "#881840",
    style: {
      fill: "#cd4d7a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.278821,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Score",
    transform: "matrix(0.14251664,0,0,0.14251664,318.98466,722.19592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_979",
    "data-name": "Tracciato 979",
    d: "m 26.8,0 -16.775,3.161 -9.734,21.175 7.4,13.255 19.109,8.17 16.8,-6.242 5.595,-16.794 -6,-16.385 z",
    transform: "rotate(180,-81.979,-1767.4415)",
    fill: "#881840"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_730",
    "data-name": "Raggruppa 730",
    transform: "translate(2.695,2.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1164",
    "data-name": "Tracciato 1164",
    d: "m 721.711,588.595 -3.6,3.9 -3.122,-4.291 3.6,-3.9 z",
    transform: "translate(-915.346,-4146.02)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1165",
    "data-name": "Tracciato 1165",
    d: "m 731.734,588.2 -3.114,4.3 -3.608,-3.892 3.114,-4.3 z",
    transform: "translate(-917.209,-4146.019)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1166",
    "data-name": "Tracciato 1166",
    d: "m 726.721,597.242 -3.643,3.859 -3.078,-4.324 3.643,-3.859 z",
    transform: "translate(-916.278,-4147.62)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1167",
    "data-name": "Tracciato 1167",
    d: "m 737.152,580.352 -3.682,3.821 -3.031,-4.356 3.682,-3.817 z",
    transform: "translate(-918.217,-4144.476)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1168",
    "data-name": "Tracciato 1168",
    d: "m 716.393,579.887 -3.123,4.29 -3.6,-3.9 3.122,-4.291 z",
    transform: "translate(-914.359,-4144.474)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1169",
    "data-name": "Tracciato 1169",
    d: "m 726.719,579.812 -3.024,4.36 -3.688,-3.815 3.024,-4.357 z",
    transform: "translate(-916.279,-4144.476)",
    fill: "#ffffff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetScore);
export default __webpack_public_path__ + "static/media/NetScore.3ef7e8bc0699b2174ea938f85ad08abb.svg";
export { ForwardRef as ReactComponent };